import {
  InLifeEnergyTariffsUnavailableDialog,
  InLifeExitDialog,
  InLifeSessionTimedOutDialog,
  InLifeStartAgainDialog,
} from '@in-life/features/dialogs';
import {
  EnergyPage,
  EnergyTariffForm,
  InLifeErrorBoundary,
  OrderConfirmPage,
  ThankYouPage,
} from '@in-life/pages';
import { Navigate, Outlet } from 'react-router-dom';

import { PagePaths } from '@constants/paths';
import { EnergyDetails } from '@pages/index.ts';
import { UpdatedTariffModalProvider } from '@providers/basket';
import { BasketGuard } from '@routing/BasketGuard';

import { InLifeRouteProvider } from './providers/RouteProvider';
import { InLifeTracking } from './tracking';

const inLifeRoutes = [
  {
    path: '',
    // `errorElement` lives on the child so the dialogs below stay mounted
    // on page error and can still be opened.
    element: (
      <>
        <InLifeExitDialog />
        <InLifeSessionTimedOutDialog />
        <InLifeStartAgainDialog />
        <InLifeTracking />
        <Outlet />
      </>
    ),
    children: [
      {
        path: '',
        element: <InLifeRouteProvider />,
        errorElement: <InLifeErrorBoundary />,
        children: [
          {
            path: '',
            element: <Navigate to={PagePaths.Energy} replace />,
          },
          {
            path: PagePaths.Energy,
            element: <EnergyPage />,
            children: [
              {
                element: (
                  <>
                    <Outlet />
                    <InLifeEnergyTariffsUnavailableDialog />
                  </>
                ),
                children: [
                  {
                    path: '',
                    element: <EnergyTariffForm />,
                  },
                  {
                    path: PagePaths.EnergyDetails,
                    element: <EnergyDetails />,
                  },
                ],
              },
            ],
          },
          {
            path: PagePaths.Order,
            element: <BasketGuard />,
            children: [
              {
                path: PagePaths.Confirm,
                element: (
                  <UpdatedTariffModalProvider>
                    <OrderConfirmPage />
                  </UpdatedTariffModalProvider>
                ),
              },
              {
                path: PagePaths.ThankYou,
                element: <ThankYouPage />,
              },
            ],
          },
          {
            path: '*',
            element: <Navigate to="/" replace />,
          },
        ],
      },
    ],
  },
];

export { inLifeRoutes };
